import {importScript} from 'io/imports';
import createCachedLoader from './createCachedLoader';

export default (url, getResult = () => undefined) =>
	createCachedLoader(() => {
		const concreteUrl = typeof url === 'function' ? url() : url;
		return importScript(concreteUrl).then(getResult);
	});
